import { useEffect, useState } from 'react';

export default function Hero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=luxurious%20beauty%20clinic%20interior%20with%20soft%20pink%20and%20gold%20lighting%2C%20elegant%20treatment%20room%20with%20cream%20walls%2C%20champagne%20gold%20accents%2C%20lush%20white%20flowers%2C%20professional%20skincare%20equipment%20subtly%20visible%2C%20warm%20ambient%20glow%2C%20ultra%20premium%20spa%20atmosphere&width=1920&height=1080&seq=hero001&orientation=landscape')`,
        }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/60 via-black/40 to-[#D4AF37]/20" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />

      {/* Floating light orbs */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#FFB3C6]/10 rounded-full blur-3xl animate-pulse" />
      <div className="absolute bottom-1/3 right-1/4 w-80 h-80 bg-[#D4AF37]/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />

      {/* Content */}
      <div className={`relative z-10 w-full max-w-5xl mx-auto px-6 md:px-12 text-center transition-all duration-1000 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/30 text-white/90 text-xs font-medium px-4 py-2 rounded-full mb-6 tracking-wider uppercase">
          <span className="w-1.5 h-1.5 bg-[#D4AF37] rounded-full animate-pulse"></span>
          Profesyonel Güzellik &amp; Estetik
        </div>

        {/* Main Headline */}
        <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white leading-tight mb-6 drop-shadow-lg">
          Güzelliğinize
          <br />
          <span className="italic text-[#D4AF37]">Profesyonel</span>
          <br />
          Dokunuş
        </h1>

        {/* Subtext */}
        <p className="text-white/85 text-base md:text-lg max-w-2xl mx-auto mb-4 leading-relaxed font-light">
          Kişiye özel analiz, profesyonel uygulama, doğal ve kalıcı sonuçlar
        </p>
        <p className="text-[#D4AF37]/90 text-sm tracking-widest uppercase mb-10 font-medium">
          Ayfer Çetin Güzellik Salonu
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="#iletisim"
            className="flex items-center gap-2 bg-white text-[#2D2D2D] px-7 py-4 rounded-full text-sm font-semibold hover:bg-[#FFF8F0] hover:-translate-y-1 transition-all duration-300 shadow-lg whitespace-nowrap w-full sm:w-auto justify-center"
          >
            <i className="ri-calendar-check-line text-[#D4AF37]"></i>
            RANDEVU SORGULA
          </a>
          <a
            href="https://wa.me/905412190629"
            target="_blank"
            rel="nofollow noreferrer"
            className="flex items-center gap-2 bg-[#25D366] text-white px-7 py-4 rounded-full text-sm font-semibold hover:bg-[#1DA851] hover:-translate-y-1 transition-all duration-300 shadow-lg whitespace-nowrap w-full sm:w-auto justify-center"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            WHATSAPP İLETİŞİM
          </a>
        </div>

        {/* Stats */}
        <div className="flex items-center justify-center gap-6 md:gap-12">
          {[
            { num: '500+', label: 'Mutlu Danışan' },
            { num: '10+', label: 'Yıl Deneyim' },
            { num: '15+', label: 'Premium Hizmet' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-white font-serif text-2xl md:text-3xl font-bold">{stat.num}</p>
              <p className="text-white/70 text-xs uppercase tracking-wider">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/60 text-xs uppercase tracking-widest">Keşfet</span>
        <i className="ri-arrow-down-line text-white/60 text-lg"></i>
      </div>
    </section>
  );
}
